import { render, staticRenderFns } from "./pickRaterDialog.vue?vue&type=template&id=152af558"
import script from "./pickRaterDialog.vue?vue&type=script&lang=js"
export * from "./pickRaterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152af558')) {
      api.createRecord('152af558', component.options)
    } else {
      api.reload('152af558', component.options)
    }
    module.hot.accept("./pickRaterDialog.vue?vue&type=template&id=152af558", function () {
      api.rerender('152af558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory2/sensory-report/pickRaterDialog.vue"
export default component.exports